export const LIBRARY_TABLE_NAME_COLUMN_KEY = 'name';
export const LIBRARY_TABLE_INSIGHTS_COLUMN_KEY = 'insights';
export const LIBRARY_TABLE_SPACE_COLUMN_KEY = 'space';
export const LIBRARY_TABLE_CREATOR_COLUMN_KEY = 'creator';
export const LIBRARY_TABLE_LAST_MODIFIED_COLUMN_KEY = 'lastModified';
export const LIBRARY_TABLE_ACTIONS_COLUMN_KEY = 'actions';

export const LIBRARY_TABLE_SORTABLE_COLUMNS = [
  LIBRARY_TABLE_NAME_COLUMN_KEY,
  LIBRARY_TABLE_SPACE_COLUMN_KEY,
  LIBRARY_TABLE_CREATOR_COLUMN_KEY,
  LIBRARY_TABLE_INSIGHTS_COLUMN_KEY,
  LIBRARY_TABLE_LAST_MODIFIED_COLUMN_KEY,
];
